var LS = LS || window.LS || {};
var dataLayer = window.dataLayer || [];

LS.getHeader = function () {
    var $ = jQuery;
    return $('#site-header');
}

LS.getScrollTo = function (el, offset) {
    return el.offset().top;
    // return el.offset().top - offset - 30; // offset added to accomodate fixed header plus a little extra for space below header after the scroll
};

LS.returnFocus = function () {
    if (window.returnFocusTo) {
        window.returnFocusTo.focus();
        window.returnFocusTo = null;
    }
}

LS.isEscape = function (e) {
    // keyCode is getting deprecated use key instead when supported, which makes this messy
    var evt = e || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key == "Escape" || evt.key == "Esc");
    } else {
        isEscape = (evt.keyCode == 27);
    }
    return isEscape;
};

LS.trapFocus = function (elementId, focusFirst = true) {
    const focusableElements = 'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';
    const trap = document.querySelector(elementId); // select the trap by it's id
    // remove any hidden elements
    let focusableContent = Array.from(trap.querySelectorAll(focusableElements));
    focusableContent = focusableContent.filter(element => {
        return element.offsetWidth > 0 || element.offsetHeight > 0;
    });
    const firstFocusableElement = focusableContent[0]; // get first element to be focused inside trap
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside trap
    document.addEventListener('keydown', function (e) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    });
    if (focusFirst) {
        setTimeout(() => {
            firstFocusableElement.focus();
        }, 350);
    }
};

LS.updateFreeShippingMessages = function (cartTotal = window.theme.cartTotal) {
    var $marquee = $("#marquee");
    var $marqueeSlider = $marquee.find(".items");
    var $cartMessage = $("#free-shipping-message");
    var $shippingItem = $marqueeSlider.find(".appended");
    let threshold = Number(marqueeStrings.threshold);
    if (threshold === 0) {
        $marqueeSlider.slick('slickRemove', $shippingItem.index());
        return;
    }
    if (cartTotal >= threshold) {
        $shippingItem.html(marqueeStrings.over);
        $cartMessage.html(marqueeStrings.over);
        if ($cartMessage.length) {
            $cartMessage[0].style.setProperty("--progress", "100%");
        }
    } else if (cartTotal > 0) {
        var underMessage = marqueeStrings.under.replace(
            "{amt}",
            ((threshold - cartTotal) / 100).toFixed(2)
        );
        $shippingItem.html(underMessage);
        $cartMessage.html(underMessage);
        if ($cartMessage.length) {
            $cartMessage[0].style.setProperty(
                "--progress",
                ((cartTotal / threshold) * 100).toFixed(2) + "%"
            );
        }
    } else {
        if ($cartMessage.length) {
            $cartMessage.html("");
            $cartMessage[0].style.setProperty("--progress", 0);
        }
    }
}

// we only want to report video watched events once per page to not over-report
var reported25 = false;
var reported50 = false;
var reported75 = false;
var reported100 = false;

LS.tabletBreakpoint = 768;
LS.desktopBreakpoint = 1025;
LS.largeBreakpoint = 1400;
LS.galleries = [];

LS.keys = {
    declined: 'welcome-declined',
    subscribed: 'is-subscribed',
    registrationData: 'registration-data'
};

LS.reportVideoProgress = function (currentTime, duration) {
    var completed = currentTime / duration;
    if (completed >= 0.25 && !reported25) {
        reported25 = true;
        dataLayer.push({
            'event': 'videoProgress',
            'videoProgress': 25
        });
    } else if (completed >= 0.5 && !reported50) {
        reported50 = true;
        dataLayer.push({
            'event': 'videoProgress',
            'videoProgress': 50
        });
    } else if (completed >= 0.75 && !reported75) {
        reported75 = true;
        dataLayer.push({
            'event': 'videoProgress',
            'videoProgress': 75
        });
    } else if (completed == 0 && !reported100) { // first update will be > 0, so when we hit 0 again, the video finished and started over
        reported100 = true;
        dataLayer.push({
            'event': 'videoProgress',
            'videoProgress': 100
        });
    }
};

LS.productVideoOpen = function (videoId) {
    var $ = jQuery;
    var $container = $('#product-video-container');
    var dataLayer = window.dataLayer || [];
    var embedCode = '';


    // video{n}Embed variables are defined in /app/design/frontend/lo-rwd/default/template/catalog/product/view.phtml
    switch (videoId) {
        case 2:
            embedCode = video2Embed;
            break;
        case 3:
            embedCode = video3Embed;
            break;
        case 4:
            embedCode = video4Embed;
            break;
        case 5:
            embedCode = video5Embed;
            break;
        case 6:
            embedCode = video6Embed;
            break;
        default:
            embedCode = video1Embed;
            break;
    }

    // embed it
    $container.prepend(embedCode);
    initVideowise();
    var $iframe = $container.find('iframe');
    var mediaWidth = $iframe.attr('width');
    var mediaHeight = $iframe.attr('height');
    var $video = $container.find('video');
    if (!$iframe.length) {
        mediaWidth = $video.find('source').first().attr('width');
        mediaHeight = $video.find('source').first().attr('height');
    }

    // set the width to a value that makes the height of the embed 80% of the window height,
    // then convert that width to a percentage of the window width so it scales,
    // but only when that size isn't wider than the current window
    // var iframeEmbedWidth = $iframe.attr('width');
    // var ratio = ($(window).height() * 0.8) / mediaHeight;
    // // console.log(mediaWidth * ratio, $(window).width());
    // if (mediaWidth * ratio > $(window).width()) {
    //     $container.css('width', '100%');
    // } else {
    //     $container.css('width', ((mediaWidth * ratio) / $(window).width()) * 100 + '%');
    // }

    // responsify it now that we have its size defined
    // $container.fitVids();

    // show it

    $('#product-video').addClass('shown');
    $('#product-video').focus();
    LS.trapFocus('#product-video');

    // center it in the window, do this after the fade in so the height is available. The user shouldn't see the shift.
    // $container.css('margin-top', '-' + ($container.outerHeight() / 2) + 'px');

    if ($video.length) {
        $video.css('aspect-ratio', `${mediaWidth} / ${mediaHeight}`);
        $video[0].play();
    }
    if ($iframe.length) {
        $iframe.css('aspect-ratio', `${mediaWidth} / ${mediaHeight}`);
        // use the vimeo API to auto-play
        // NOTE: iOS doesn't allow js to auto-play media, so the user will still have to click play.
        var player = new Vimeo.Player($iframe[0]);

        // only attempt the auto play for desktop. Vimeo changed something so autoplay attempts will leave the video in a paused state.
        if ($(window).width() >= LS.desktopBreakpoint) {
            player.play();
        }

        player.on('play', function (data) {
            player.getVideoTitle().then(function (title) {
                dataLayer.push({
                    'event': 'videoStart',
                    'videoName': title
                });
            }).catch(function (error) {
                console.log(error);
            });
        });
        player.on('ended', function (data) {
            player.getVideoTitle().then(function (title) {
                LS.reportVideoProgress(0, 1);// pass 0 as current time to indicate 100% watched
                dataLayer.push({
                    'event': 'videoEnd',
                    'videoName': title
                });
            }).catch(function (error) {
                console.log(error);
            });
        });
        player.on('timeupdate', function (data) {
            LS.reportVideoProgress(data.seconds, data.duration);
        });
    }
};

LS.productVideoClose = function () {
    var $ = jQuery;
    $('#product-video').removeClass('shown');
    $('#product-video-container').html('');
};

LS.isElementInViewport = function (el) {
    var rect = el.getBoundingClientRect();
    return (
        // rect.top >= 0 &&
        // rect.left >= 0 &&
        rect.bottom >= 0 && // if bottom < 0, element has scrolled out of view
        // rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */

        rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
};

LS.throttle = function (wait, func, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function () {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
};

LS.debounce = function (func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
};



LS.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function (array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function (array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function (array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function (value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
    },

    /**
     * Returns the closest parent based on a
     * selector match.
     *
     * @param {*} elem
     * @param {*} selector
     */
    getClosest: function (elem, selector) {
        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    let matches = (this.document || this.ownerDocument).querySelectorAll(s)
                    let i = matches.length
                    while (--i >= 0 && matches.item(i) !== this) { }
                    return i > -1
                }
        }

        // Get the closest matching element
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector)) return elem
        }
        return null
    }
};

LS.cart = {

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function () {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    }
};

LS.Currency = (function () {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = LS.utils.defaultTo(precision, 2);
            thousands = LS.utils.defaultTo(thousands, ',');
            decimal = LS.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();
